<mat-toolbar color="primary">
    <span>Traitements</span>
    <button (click)="newTreatment()" mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
        <mat-icon>note_add</mat-icon>
    </button>
    <span class="toolbar-spacer"></span>
    <button mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
        <mat-icon>search</mat-icon>
    </button>    
</mat-toolbar>
<app-medication-table [location]="'panel'"></app-medication-table>